module.exports = __webpack_public_path__ + "img/2_202.7e619c9e.png";